<style>
/* Estilo para el div */
.slide {
  animation: aparecer 1s;
}
@keyframes aparecer {
  from {
    opacity: 0;
    transform: translate(10%, -10%);
  }
  to {
    opacity: 1;
    transform: translate(0);
  }
}
</style>
<template>
  <div class="form-group">
    <label
      v-bind:class="{
        'text-danger': current.errors && current.errors[propname],
      }"
      >{{ label }}</label
    >
    <div class="row">
      <div class="col-11">
        <v-select
          label="nombre"
          v-model="current[propname]"
          :filterable="false"
          @input="onChangeCuentaContable"
          :options="cuentas_contables"
          @search="onSearch"
        >
          <template slot="no-options">{{ label }}...</template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              <img :src="option.image" />
              <span v-if="option"
                >{{ option.nombre_indentado }} ({{
                  option.sumaria_o_movimiento_str
                }})</span
              >
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              <img :src="option.image" />
              <span v-if="option && option.nombre_indentado"
                >{{ option.nombre_indentado }} ({{
                  option.sumaria_o_movimiento_str
                }})</span
              >
            </div>
          </template>
        </v-select>
      </div>
      <div class="col-1" style="padding: 0px">
        <a @click="mostrarDetalle()" class="btn btn-success btn-sm"
          ><i class="fas fa-eye"></i
        ></a>
        <div
          v-if="showModal"
          class="modal-popup"
          style="width: 600px; overflow-y: hidden"
        >
          <div style="overflow-y: scroll; max-height: 420px">
            <i
              @click="ResetArbol()"
              v-bind:class="{
                'fas fa-caret-right': index_open.length == 0,
                'fas fa-caret-down': index_open.length > 0,
              }"
              class="text-success"
              style="font-size: 20px"
            ></i>
            &nbsp;<a class="text-success" @click="ResetArbol()">contraer</a>
            <!-------------------- Tabla de REsultados -------------------->
            <table class="table table-striped">
              <tbody>
                <tr v-for="det in datatreeview" v-bind:key="det.id">
                  <td>
                    <i
                      @click="AbrirArbol(det)"
                      v-bind:class="{
                        'fas fa-caret-right': !index_open.includes(det.id),
                        'fas fa-caret-down': index_open.includes(det.id),
                      }"
                      class="text-success"
                      style="font-size: 23px"
                    ></i
                    >&nbsp;
                    <a class="text-dark" @click="AbrirArbol(det)"
                      >{{ det.id }} - {{ det.nombre }}</a
                    >
                    &nbsp;
                    <i
                      class="text-success"
                      v-bind:class="{
                        'ic-w mx-1 os-icon os-icon-bar-chart-up os-icon os-icon-refresh-ccw':
                          det.sumaria_o_movimiento == 'S',
                        'fas fa-redo': det.sumaria_o_movimiento == 'M',
                      }"
                    ></i>
                    &nbsp;<button
                      @click="SelectItem(det)"
                      class="btn btn-light btn-sm text-info"
                    >
                      <i class="fas fa-fas fa-location-arrow"></i> &nbsp; selec.
                    </button>
                    <table v-if="index_open.includes(det.id)" class="table table-striped">
                      <tr class="slide" v-for="det2 in det.hijos" v-bind:key="det2.id">
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <i
                            @click="AbrirArbol(det2)"
                            v-bind:class="{
                              'fas fa-caret-right': !index_open.includes(det2.id),
                              'fas fa-caret-down': index_open.includes(det2.id),
                            }"
                            class="text-success"
                            style="font-size: 23px"
                          ></i
                          >&nbsp;<a class="text-dark" @click="AbrirArbol(det2)"
                            >{{ det2.id }} - {{ det2.nombre }}</a
                          >
                          &nbsp;
                          <i
                            class="text-success"
                            v-bind:class="{
                              'ic-w mx-1 os-icon os-icon-bar-chart-up os-icon os-icon-refresh-ccw':
                                det2.sumaria_o_movimiento == 'S',
                              'fas fa-redo': det2.sumaria_o_movimiento == 'M',
                            }"
                          ></i>
                          &nbsp;<button
                            @click="SelectItem(det2)"
                            class="btn btn-light btn-sm text-info"
                          >
                            <i class="fas fa-fas fa-location-arrow"></i> &nbsp; selec.
                          </button>
                          <table
                            v-if="index_open.includes(det2.id)"
                            class="table table-striped"
                          >
                            <tr
                              class="slide"
                              v-for="det3 in det2.hijos"
                              v-bind:key="det3.id"
                            >
                              <td>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <i
                                  @click="AbrirArbol(det3)"
                                  v-bind:class="{
                                    'fas fa-caret-right': !index_open.includes(det3.id),
                                    'fas fa-caret-down': index_open.includes(det3.id),
                                  }"
                                  class="text-success"
                                  style="font-size: 23px"
                                ></i
                                >&nbsp;
                                <a class="text-dark" @click="AbrirArbol(det3)"
                                  >{{ det3.id }} - {{ det3.nombre }}</a
                                >
                                &nbsp;
                                <i
                                  class="text-success"
                                  v-bind:class="{
                                    'ic-w mx-1 os-icon os-icon-bar-chart-up os-icon os-icon-refresh-ccw':
                                      det3.sumaria_o_movimiento == 'S',
                                    'fas fa-redo': det3.sumaria_o_movimiento == 'M',
                                  }"
                                ></i
                                >&nbsp;<button
                                  @click="SelectItem(det3)"
                                  class="btn btn-light btn-sm text-info"
                                >
                                  <i class="fas fa-fas fa-location-arrow"></i> &nbsp;
                                  selec.
                                </button>
                                <table
                                  v-if="index_open.includes(det3.id)"
                                  class="table table-striped"
                                >
                                  <tr
                                    class="slide"
                                    v-for="det4 in det3.hijos"
                                    v-bind:key="det4.id"
                                  >
                                    <td>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <i
                                        @click="AbrirArbol(det4)"
                                        v-bind:class="{
                                          'fas fa-caret-right': !index_open.includes(
                                            det4.id
                                          ),
                                          'fas fa-caret-down': index_open.includes(
                                            det4.id
                                          ),
                                        }"
                                        class="text-success"
                                        style="font-size: 23px"
                                      ></i
                                      >&nbsp;
                                      <a class="text-dark" @click="AbrirArbol(det4)"
                                        >{{ det4.id }} - {{ det4.nombre }}</a
                                      >
                                      &nbsp;
                                      <i
                                        class="text-success"
                                        v-bind:class="{
                                          'ic-w mx-1 os-icon os-icon-bar-chart-up os-icon os-icon-refresh-ccw':
                                            det4.sumaria_o_movimiento == 'S',
                                          'fas fa-redo': det4.sumaria_o_movimiento == 'M',
                                        }"
                                      ></i
                                      >&nbsp;<button
                                        @click="SelectItem(det4)"
                                        class="btn btn-light btn-sm text-info"
                                      >
                                        <i class="fas fa-fas fa-location-arrow"></i>
                                        &nbsp; selec.
                                      </button>
                                      <table
                                        v-if="index_open.includes(det4.id)"
                                        class="table table-striped"
                                      >
                                        <tr
                                          class="slide"
                                          v-for="det5 in det4.hijos"
                                          v-bind:key="det5.id"
                                        >
                                          <td>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <a @click="current.cuenta_contable = det5"
                                              >{{ det5.id }} - {{ det5.nombre }}</a
                                            >
                                            &nbsp;
                                            <i
                                              class="text-success"
                                              v-bind:class="{
                                                'ic-w mx-1 os-icon os-icon-bar-chart-up os-icon os-icon-refresh-ccw':
                                                  det5.sumaria_o_movimiento == 'S',
                                                'fas fa-redo':
                                                  det5.sumaria_o_movimiento == 'M',
                                              }"
                                            ></i
                                            >&nbsp;<button
                                              @click="SelectItem(det5)"
                                              class="btn btn-light btn-sm text-info"
                                            >
                                              <i class="fas fa-fas fa-location-arrow"></i>
                                              &nbsp; selec.
                                            </button>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-------------------- END - Basic Table -------------------->
          </div>
          <div class="modal-footer">
            <!-- Contenedor con posición fixed en la parte inferior -->
            <div>
              <!-- Botón "Cerrar" -->
              <button @click="showModal = false" class="btn btn-dark btn-sm">
                <i class="fas fa-door-open"></i> Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <small
      v-if="current.errors && current.errors[propname]"
      class="form-text text-danger"
      >{{ current.errors[propname] }}</small
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CuentaContableService from "@/services/conta/CuentaContableService";
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
    },
    propname: {
      type: String,
      default: "cuenta_contable",
    },
    label: {
      type: String,
      default: "Cuenta Contable",
    },
  },
  data() {
    return {
      showModal: false,
      datatreeview: [],
      params: {},
      index_open: [],
    };
  },
  computed: {
    ...mapGetters({
      cuentas_contables: "conta/cuentas_contables",
    }),
  },
  mounted() {
    this.refreshData();
    this.$store.dispatch("conta/cuentas_contables", {
      activo: true,
      quitar_paginacion: true,
    });
  },
  methods: {
    SelectItem(det) {
      let self = this;
      DynamicService.getById("conta", "cuenta-contable", det.id).then((response) => {
        self.current[self.propname] = response.data;
      });
    },
    AbrirArbol(det) {
      let self = this;
      if (self.index_open.includes(det.id)) {
        self.index_open = self.index_open.filter((item) => item !== det.id);

        return;
      }
      self.index_open.push(det.id);
    },
    ResetArbol() {
      let self = this;
      self.index_open = [];
    },
    mostrarDetalle() {
      let self = this;
      let params = {};
      if (this.showModal == true) {
        this.showModal = false;
        return;
      }
      self.showModal = true;
    },
    refreshData() {
      let self = this;
      CuentaContableService.treeview().then((res) => {
        self.datatreeview = res.data;
        self.data = [];
      });
    },
    onChangeCuentaContable(event) {
      this.$emit("onChangeCuentaContable", event);
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("conta/cuentas_contables", {
        page: 1,
        activo: true,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),
  },
};
</script>
